import { render, staticRenderFns } from "./PreviewUploadedFile.vue?vue&type=template&id=45645062&scoped=true"
import script from "./PreviewUploadedFile.vue?vue&type=script&lang=js"
export * from "./PreviewUploadedFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45645062",
  null
  
)

export default component.exports